var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDiners(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 31,
    viewBox: "0 0 46 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.45,
    width: 46,
    height: 30.1,
    rx: 3,
    fill: "#397fba"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.47,26.9c6.23,0,11.92-5.08,11.92-11.3A11.65,11.65,0,0,0,25.47,4.1H20.11A11.25,11.25,0,0,0,8.61,15.6a11.42,11.42,0,0,0,11.5,11.3Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,21.65V9.31a6.6,6.6,0,0,1,0,12.34m-9-6.17a6.6,6.6,0,0,1,4.24-6.17V21.65a6.6,6.6,0,0,1-4.24-6.17M20.13,5A10.44,10.44,0,1,0,30.57,15.48,10.44,10.44,0,0,0,20.13,5",
    fill: "#3980ba"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDiners);
export default __webpack_public_path__ + "static/media/ic_diners.9a3ac78afb6551f58307ffdd348ffe9e.svg";
export { ForwardRef as ReactComponent };